import $ from 'jquery';

export default function Home() {
  if ($(".label-teaser").length > 0) {
    import('teaser/brand_teaser').then(BrandTeaser => new BrandTeaser.default());
  }

  if ($(".news-teaser").length > 0) {
    import('teaser/news_teaser').then(NewsTeaser => new NewsTeaser.default());
  }

  if ($("#js-category-finder").length > 0) {
    import('teaser/category_finder_teaser').then(CategoryFinderTeaser => new CategoryFinderTeaser.default());
  }

  if ($(".parallax-teaser").length > 0) {
    import('teaser/parallax_teaser').then(ParallaxTeaser => new ParallaxTeaser.default());
  }

  if ($(".assortment-access-teaser").length > 0) {
    import('teaser/assortment_access_teaser').then(AssortmentAccessTeaser => (new AssortmentAccessTeaser.default()).init());
  }

  if ($(".number-input-extra-button, .js-quantity-field").length > 0) {
    import('utils/form_elements/number_plus_minus_buttons').then(NumberPlusMinusButtons => (new NumberPlusMinusButtons.default()).init());
  }
}
